import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import {
    errorMessage,
    formatDate,
} from "../../../util/Helpers";
import SVG from "react-inlinesvg";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { Permissions, PermissionType } from "../../../util/Permissions";

import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permission } from "../../Common/layout/Permission"
import { EditIcon, ViewIcon } from "../../../util/Icons";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CreateSecurityQuestionModal from "./modals/CreateSecurityQuestionModal";
import EditSecurityQuestionModal from "./modals/EditSecurityQuestionModal";
import DisableSecurityQuestionModal from "./modals/DisableSecurityQuestionModal";

export const SecurityQuestions = (
    {
        match: {
            params: { userGroup },
        },
    }
) => {
    const tableRef = useRef();

    /* Security Question Modal State Management */
    const [securityQuestionModal, setSecurityQuestionModal] = useState({
        showCreateSecurityQuestionModal: false,
        showEditSecurityQuestionModal: false,
        showDeleteSecurityQuestionModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setSecurityQuestionModal({
            ...securityQuestionModal,
            [modal]: !securityQuestionModal[modal],
            // Reset details when closing modal
            details: !securityQuestionModal[modal] ? securityQuestionModal.details : null
        })
    }

    /* Create Security Question */
    const createSecurityQuestion = () => {
        setSecurityQuestionModal({
            ...securityQuestionModal,
            showCreateSecurityQuestionModal: true,
            details: null
        })
    }

    /* Edit Security Question */
    const editSecurityQuestion = details => {
        setSecurityQuestionModal({
            ...securityQuestionModal,
            showEditSecurityQuestionModal: true,
            details
        })
    }

    /* Delete Security Question */
    const deleteSecurityQuestion = (details) => {
        setSecurityQuestionModal({
            ...securityQuestionModal,
            showDeleteSecurityQuestionModal: true,
            details,
        });
    };

    /* Action Buttons */
    const securityQuestionAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="Edit Security Question"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3`}
                    onClick={_ => editSecurityQuestion(row)}
                >
                    <span className={`svg-icon svg-icon-md svg-icon-primary`}>
                        <EditIcon />
                    </span>
                </Button>
                <Button
                    title="Delete Security Question"
                    className={`btn btn-icon btn-light btn-hover-danger btn-sm mx-3`}
                    onClick={_ => deleteSecurityQuestion(row)}
                >
                    <span className={`svg-icon svg-icon-md svg-icon-danger`}>
                        <SVG
                            title="Delete Security Question"
                            src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                        />
                    </span>
                </Button>
            </span>
        );
    };

    return (
        <div className="py-4 px-6">
            <FilterGroup key={userGroup}>
                <FilterGroup.Content>
                    {
                        ({ filters }) => {
                            return <Card>
                                <CardHeader title={`Security Questions`}>
                                    <Permission
                                        permission={Permissions.SECURITY_QUESTIONS}
                                        permissionType={PermissionType.CREATE}
                                    >
                                        <CardHeaderToolbar>
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={createSecurityQuestion}
                                            >
                                                Add Security Question
                                            </button>
                                        </CardHeaderToolbar>
                                    </Permission>
                                </CardHeader>
                                <CardBody>
                                    <DynamicSimpleTable
                                        key={userGroup}
                                        queryParams={`userGroup=${userGroup}`}
                                        searchBox={false}
                                        source={{ url: `/security-question` }}
                                        columns={[
                                            {
                                                title: "Security Question",
                                                key: "question"
                                            },
                                            {
                                                title: "Date Created",
                                                format: (row) => formatDate(row.created)
                                            },
                                            {
                                                title: "Updated Date",
                                                format: (row) => formatDate(row.updated)
                                            },
                                            {
                                                title: "Actions",
                                                format: securityQuestionAction
                                            }
                                        ]}
                                        ref={tableRef}
                                        onError={(err) => cogoToast.error(errorMessage(err))}
                                        refreshIcon={true}
                                    />
                                </CardBody>
                            </Card>
                        }
                    }
                </FilterGroup.Content>
            </FilterGroup>

            {/* Create Security Question Modal */}
            <CreateSecurityQuestionModal
                showCreateSecurityQuestionModal={securityQuestionModal.showCreateSecurityQuestionModal}
                onHide={toggleModal("showCreateSecurityQuestionModal")}
                userGroup={userGroup}
                tableRef={tableRef}
            />


            {/* Edit Security Question Modal */}
            <EditSecurityQuestionModal
                showEditSecurityQuestionModal={securityQuestionModal.showEditSecurityQuestionModal}
                details={securityQuestionModal.details}
                onHide={toggleModal("showEditSecurityQuestionModal")}
                tableRef={tableRef}
            />

            <DisableSecurityQuestionModal
                showDisableSecurityQuestionModal={securityQuestionModal.showDeleteSecurityQuestionModal}
                details={securityQuestionModal.details}
                onHide={toggleModal("showDeleteSecurityQuestionModal")}
                tableRef={tableRef}
            />

        </div>
    );
};